import {
  GET_HEALTH_CHECK_SYNC_BILLING_STARTED,
  GET_HEALTH_CHECK_SYNC_BILLING_SUCCESS
} from '../../actions/actionTypes'

const defaultState = {
  hotelData: [],
  hotelGroups: {},
  hotelChains: {},
  isLoading: true
}

export default function billings(state = { ...defaultState }, action) {
  switch (action.type) {
    case GET_HEALTH_CHECK_SYNC_BILLING_STARTED:
      return {
        ...state,
        isLoading: true
      }

    case GET_HEALTH_CHECK_SYNC_BILLING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hotelData: action.payload.hotelData,
        hotelGroups: action.payload.hotelGroups,
        hotelChains: action.payload.hotelChains
      }

    case 'SAVE_POSTED_SUBSIDIARY':
      return {
        ...defaultState
      }

    default:
      return state
  }
}
